import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import styles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";
import style from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import { localApi } from "utils/imgApi";
import styleSweet from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import SweetAlert from "react-bootstrap-sweetalert";

const useStyles = makeStyles(styles);
const useStyle = makeStyles(style);
const useStyleSweet = makeStyles(styleSweet);

export default function DeleteBox() {
  const [items, setItems] = React.useState([]);
  const [simpleSelect, setSimpleSelect] = React.useState("");
  const [boxDesc, setBoxDesc] = React.useState("");
  const [brandName, setBrandName] = React.useState("");
  const [packingCharge, setPackingCharge] = React.useState("");
  const [box, setBox] = React.useState("");
  const [hsncode, setHsncode] = React.useState("");
  const [price, setPrice] = React.useState("");
  const [ligst, setLigst] = React.useState("");
  const [getId, setGetId] = React.useState("");
  const [submitted, setSubmitted] = React.useState(false);
  const [alertType, alertTypeOps] = React.useState("");
  const [alertMsg, alertMsgOps] = React.useState("");
  const [btn, setBtn] = React.useState(false);

  const classes = useStyles();
  const classe = useStyle();
  const classSweet = useStyleSweet();

  const userObj = JSON.parse(sessionStorage.getItem("sessionData"));

  async function getUsers() {
    const api = localApi + `/box/list/byAdminId/${userObj && userObj.id}`;
    const result = await fetch(api);
    const getResult = await result.json();
    setItems(getResult && getResult);
    // console.log(getResult.BoxData);
  }

  useEffect(() => {
    getUsers();
  }, []);

  const handleSimple = (event) => {
    // setSimpleSelect(event.target.value);
    const { value } = event.target;
    const item = items.find((item) => item.id === value);
    setSimpleSelect(value);
    setBoxDesc(item.boxDesc);
    setPackingCharge(item.pkgCharge);
    setBox(item.box);
    setBrandName(item.brandName);
    setHsncode(item.hsnCode);
    setPrice(item.price);
    setLigst(item.tax_percentage);
    setGetId(item.id);
  };

  const SubmitDeleteBox = () => {
    setBtn(true);
    fetch(localApi + `/box/delete/byAdminAndBoxId/${userObj.id}/${getId}`, {
      method: "DELETE",
    })
      .then((res) => res.json())
      .then((res) => {
        // console.log(res);
        if (res.message === "Deleted Successfully !!!") {
          alertTypeOps("success");
          alertMsgOps("Delete Succesfully");
          setSubmitted(true);
        }
      });
  };

  const hideAlert = () => {
    setSubmitted(false);
    window.location.reload(false);
  };

  return (
    <div>
      <GridContainer justify="center" alignItems="center">
        <GridItem xs={12} sm={6} md={6}>
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon color="rose">
                <DeleteForeverIcon />
              </CardIcon>
              <h3 className={classes.cardIconTitle}>
                <small>Delete Box</small>
              </h3>
            </CardHeader>
            <CardBody>
              <GridContainer justify="center" alignItems="center">
                {submitted ? (
                  <SweetAlert
                    type={alertType}
                    style={{ display: "block", marginTop: "-100px" }}
                    title={alertMsg}
                    onConfirm={() => hideAlert()}
                    confirmBtnCssClass={
                      classSweet.button + " " + classSweet.success
                    }
                  />
                ) : null}{" "}
                <GridItem xs={12} sm={12} md={12}>
                  <FormControl fullWidth className={classe.selectFormControl}>
                    <InputLabel
                      htmlFor="simple-select"
                      className={classe.selectLabel}
                    >
                      Select Box Description...
                    </InputLabel>
                    <Select
                      MenuProps={{
                        className: classe.selectMenu,
                      }}
                      classes={{
                        select: classe.select,
                      }}
                      value={simpleSelect}
                      onChange={handleSimple}
                      inputProps={{
                        name: "simpleSelect",
                        id: "simple-select",
                      }}
                    >
                      <MenuItem
                        disabled
                        classes={{
                          root: classe.selectMenuItem,
                        }}
                      >
                        Select Box Description...
                      </MenuItem>
                      {items &&
                        items.map((item) => (
                          <MenuItem
                            key={item.id}
                            value={item.id}
                            classes={{
                              root: classe.selectMenuItem,
                              selected: classe.selectMenuItemSelected,
                            }}
                          >
                            {item.boxDesc + " - " + item.brandName}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </GridItem>
                {simpleSelect ? (
                  <GridItem xs={12} sm={12} md={12}>
                    <h5 className={classes.cardIconTitle}>
                      <small>
                        Box Description :-{" "}
                        <span style={{ color: "black" }}>{boxDesc}</span>
                      </small>
                      <br />
                      <small>
                        Brand Name :-{" "}
                        <span style={{ color: "black" }}>{brandName}</span>
                      </small>
                      <br />
                      <small>
                        Box Packing Labour :-{" "}
                        <span style={{ color: "black" }}>{packingCharge}</span>
                      </small>
                      <br />
                      <small>
                        Box 6/12/18:-{" "}
                        <span style={{ color: "black" }}>{box}</span>
                      </small>
                      <br />
                      <small>
                        HSN Code :-{" "}
                        <span style={{ color: "black" }}>{hsncode}</span>
                      </small>
                      <br />
                      <small>
                        Price :- <span style={{ color: "black" }}>{price}</span>
                      </small>
                      <br />
                      <small>
                        GST @18% :-{" "}
                        <span style={{ color: "black" }}>{ligst}%</span>
                      </small>
                    </h5>
                  </GridItem>
                ) : (
                  ""
                )}
              </GridContainer>
              {/* <Button
                color="rose"
                onClick={SubmitDeleteBox}
                className={classes.updateProfileButton}
              >
                Delete
              </Button> */}
              {btn === true ? (
                <Button className={classes.updateProfileButton}>Delete</Button>
              ) : (
                <Button
                  color="rose"
                  onClick={SubmitDeleteBox}
                  className={classes.updateProfileButton}
                >
                  Delete
                </Button>
              )}
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
